import { alpha, Theme } from '@mui/material/styles'
import { SxProps } from '@mui/material'

export const CARD_RADIUS = 14

export const cardSurfaceSx = (theme: Theme): SxProps<Theme> => ({
    bgcolor: theme.palette.background.paper,
    borderRadius: `${CARD_RADIUS}px`,
    border: `1px solid ${alpha(theme.palette.divider, 0.55)}`,
    boxShadow: `0 1px 2px ${alpha('#1A1A2E', 0.04)}, 0 6px 20px ${alpha('#1A1A2E', 0.05)}`,
    overflow: 'hidden',
    position: 'relative',
    transition:
        'box-shadow 0.28s ease, border-color 0.28s ease, transform 0.28s ease',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        background: `linear-gradient(270deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
        opacity: 0,
        transition: 'opacity 0.28s ease',
        zIndex: -5,
    },
    "&:hover:not([data-disabled='true'])": {
        borderColor: alpha(theme.palette.primary.main, 0.18),
        boxShadow: `0 4px 8px ${alpha('#1A1A2E', 0.05)}, 0 12px 28px ${alpha(theme.palette.primary.main, 0.1)}`,
        transform: 'translateY(-2px)',
        '&::before': {
            opacity: 1,
        },
    },
})

export const cardFooterSx = (theme: Theme): SxProps<Theme> => ({
    px: 1.5,
    py: 1.25,
    bgcolor: alpha(theme.palette.grey[100], 0.65),
    borderTop: `1px solid ${alpha(theme.palette.divider, 0.7)}`,
    backdropFilter: 'blur(6px)',
})

export const cardBadgeSx = (theme: Theme): SxProps<Theme> => ({
    display: 'inline-flex',
    alignItems: 'center',
    px: 1.25,
    py: 0.375,
    borderRadius: 999,
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    lineHeight: 1.4,
    color: theme.palette.primary.main,
    bgcolor: alpha(theme.palette.primary.main, 0.08),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
})

export const cardLinkTitleSx = (theme: Theme): SxProps<Theme> => ({
    color: 'text.primary',
    textDecoration: 'underline',
    textDecorationColor: alpha(theme.palette.primary.main, 0.4),
    textUnderlineOffset: '3px',
    '&:hover': {
        color: 'primary.main',
        textDecorationColor: 'primary.main',
    },
})

export const statIconSx = (color: string) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 52,
    height: 52,
    borderRadius: '14px',
    flexShrink: 0,
    color,
    background: `linear-gradient(145deg, ${alpha(color, 0.16)}, ${alpha(color, 0.06)})`,
    border: `1px solid ${alpha(color, 0.14)}`,
    boxShadow: `0 4px 12px ${alpha(color, 0.12)}`,
    fontSize: 22,
})
